// components/sections/contact/ContactFAQ.tsx
"use client";

import { useState } from "react";
import clsx from "clsx";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { CONTACT_FAQS } from "@/data/contact-page";
import { FAQAccordionItem } from "./FAQAccordionItem";
import { HoneycombPattern } from "./HoneycombPattern";

export function ContactFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const header = useScrollReveal<HTMLDivElement>();
  const list = useScrollReveal<HTMLDivElement>();

  return (
    <section className="relative w-full overflow-hidden bg-white px-5 py-20 sm:px-9 sm:py-28 lg:px-14">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-200 to-transparent" />
      <HoneycombPattern id="faq-hex" opacity={0.05} color="#b45309" />

      <div className="relative mx-auto w-full max-w-[820px]">
        <div
          ref={header.ref}
          className={clsx(
            "transition-all duration-700 ease-out",
            header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          )}
        >
          <p className="mb-4 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[3px] text-amber-700">
            <span className="inline-block h-px w-6 bg-amber-400" />
            Good to know
          </p>
          <h2 className="text-[clamp(2rem,3.6vw,2.8rem)] font-extrabold uppercase leading-[0.96] tracking-tight text-stone-900">
            Frequently asked
          </h2>
          <p className="mt-4 text-[15px] text-stone-500 max-w-[480px]">
            Can&apos;t find what you&apos;re looking for? Drop us a message
            using the form above.
          </p>
        </div>

        <div
          ref={list.ref}
          className={clsx(
            "mt-10 transition-all duration-700 ease-out",
            list.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          )}
        >
          {CONTACT_FAQS.map((item, i) => (
            <FAQAccordionItem
              key={item.question}
              item={item}
              index={i}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex((cur) => (cur === i ? null : i))}
            />
          ))}
        </div>
      </div>
    </section>
  );
}